import { SelectField, type SelectFieldProps } from '@ff-it/form';
import type { ReactElement } from 'react';
import { createOptions, type Option } from 'options';

import { InvoiceState, invoiceStates } from './common/types';
import { InvoiceStateTag } from './common/InvoiceStateTag';

export const invoiceStateOptions: Option<InvoiceState>[] = createOptions(invoiceStates);

type InvoiceStateFieldProps = Omit<
  SelectFieldProps<Option<InvoiceState>, any, any>,
  'options' | 'loadOptions' | 'defaultOptions' | 'simple'
>;
export const formatOptionLabel = ({ value }: Option<InvoiceState>) => (
  <InvoiceStateTag state={value} appearance="naked" />
);

export function InvoiceStateField(props: InvoiceStateFieldProps): ReactElement {
  return <SelectField options={invoiceStateOptions} simple formatOptionLabel={formatOptionLabel} {...props} />;
}
